import {getWikiLang} from "./getWikiLang";

export const getWikiUrl = (market, uri = 'home') => {
    return `https://docs.fynode.com/${getWikiLang(market)}/${uri}`;
};
